module.exports = __webpack_public_path__ + "static/JetBrainsMono-Italic-06bf22283c831651e111b08000e502fc.woff2";